import $ from "jquery";

$(() => {
  $("img").each(function () {
    const $this = $(this);
    const src: string = $this.attr("src");

    if (typeof src === "undefined") {
      return;
    }

    if (src.includes("/js/admin/ckeditor/plugins/kcfinder/upload")) {
      $this.remove();
    }
  });
});
